import React, { PureComponent, Fragment } from 'react'
import styles from './OurResource.scss'
import animated from './animate.css'
import CountUp from 'react-countup'
import { Waypoint } from 'react-waypoint'
import { Element } from 'react-scroll'
export default class OurResource extends PureComponent {
  state = {
    isVisibleOurResource: false,
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isVisibleOurResource && this.state.isVisibleOurResource) {
      this.ourResource.style.position = 'relative'
      this.ourResource.style.transform = 'translateY(0) scale(1)'
      this._boxEl.forEach((element) => {
        element.style.transform = 'translateY(0)'
        element.style.opacity = '1'
      })
      this._boxNumberEl.forEach((element) => {
        element.style.transform = 'translateY(0)'
        element.style.opacity = '1'
      })
    }
  }

  checkEnterList = []
  checkEnter = (name, start = null) => () => {
    if (this.checkEnterList.indexOf(name) == -1) {
      this.checkEnterList.push(name)
      if (start) start()
    }
  }
  renderCountUp = (name, num) => (
    <CountUp className="countup" separator="," start={0} end={num}>
      {({ countUpRef, start }) => (
        <Fragment>
          <span ref={countUpRef} />
          <em style={{ color: 'inherit', fontSize: '12px', position: 'absolute', top: '0' }}>+</em>
          <Waypoint onEnter={this.checkEnter(name, start)} />
        </Fragment>
      )}
    </CountUp>
  )
  _boxEl = []
  _boxNumberEl = []
  render() {
    const items1 = [
      [1300000, 'popdaily波波黛莉', '專門報導女性感興趣的各種消息'],
      [1000000, 'popyummy波波發胖', '專門報導高熱料可口美食'],
      [600000, 'populzzang波波妝漂亮', '專門報導流行女性美妝'],
      [480000, 'popkimchi波波泡菜', '專門報導韓國流行娛樂文化'],
      [450000, 'poptour波波打卡', '專門報導最新最棒的景點'],
    ]
    const items2 = [
      [350000, 'popjapan波波日本', '專門報導日本的新奇大小事'],
      [310000, 'popstyle波波穿搭', '專門報導流行穿搭'],
      [150000, 'popcute波波小星球', '專門報導寵物萌孩'],
      [60000, 'poplove波波邱比特', '專門報導女性戀愛攻略'],
    ]
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <style jsx>{animated}</style>
        <Element name="ourResource" />
        <div className="ourResource" ref={(el) => (this.ourResource = el)}>
          <h2>PopDaily資源</h2>
          <div className="socialMedia">
            <div className="flex-wrap">
              {items1.map((item, index) => {
                return (
                  <div
                    className="box"
                    key={`ourResource${index}`}
                    ref={(el) => (this._boxEl[index] = el)}
                  >
                    <p className="number" ref={(el) => (this._boxNumberEl[index] = el)}>
                      {this.state.isVisibleOurResource &&
                        this.renderCountUp(`ourResource${index}`, item[0])}
                    </p>
                    <p className="name">{item[1]}</p>
                    <p className="script">{item[2]}</p>
                  </div>
                )
              })}
            </div>
            <div className="flex-wrap flex-wrap2">
              {items2.map((item, index) => {
                return (
                  <div
                    className="box"
                    key={`ourResource${5 + index}`}
                    ref={(el) => (this._boxEl[5 + index] = el)}
                  >
                    <p className="number" ref={(el) => (this._boxNumberEl[5 + index] = el)}>
                      {this.state.isVisibleOurResource &&
                        this.renderCountUp(`ourResource${5 + index}`, item[0])}
                    </p>
                    <p className="name">{item[1]}</p>
                    <p className="script">{item[2]}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
